import React, { useEffect, useState } from "react"
import {
    ModalHeader,
    Modal,
    ModalBody,
    Button,
    Card,
    CardBody,
    CardText,
    CardTitle,
    Col,
    FormGroup,
    Input,
    Row,
    Spinner,
    Table,
    Label,
    CardFooter
} from "reactstrap"

import { useWallet } from "../../libs/useMetaMaskWallet"
import Web3 from "web3"

import ConnectWallet from "../../Components/ConnectWallet"
import BreadCrumb from "../../Components/BreadCrumb"
import { useToast } from "../../hooks/toast"

import IERC721Metadata from "../../abi/IERC721Metadata/IERC721Metadata.json"
import SimpleNFTSurvey from "../../abi/surveys/SimpleNftSurveyERC20Alternative.json"
const NETWORKS = require("../../constants/networks.json")

const Survey = ({ survey }) => {
    const web3 = new Web3()
    const [isLoading, setIsLoading] = useState(false)
    const [processing, setProcessing] = useState(false)
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const [loadedSurvey, setLoadedSurvey] = useState([])

    const [requiredNfts, setRequiredNfts] = useState([])

    const [hasRequired, setHasRequired] = useState(false)
    const [userNfts, setUserNfts] = useState({})

    const [currentQuestion, setCurrentQuestion] = useState(0)

    const [answers, setAnswers] = useState({})

    const [selectedNft, setSelectedNft] = useState(null)

    const [detailView, setDetailView] = useState(false)

    const [openAnswers, setOpenAnswers] = useState(false)

    const toast = useToast()
    const wallet = useWallet()

    const surveyDisable = false // set true to disable staking UI

    useEffect(() => {
        ;(async () => {
            setIsLoading(true)
            if (updateConnection() && wallet.account && survey && wallet.chainId === NETWORKS[survey?.network]?.chainId) {
                web3.setProvider(wallet.ethereum.provider)
                try {
                    let surveyContract = new web3.eth.Contract(SimpleNFTSurvey, survey.contractAddress)

                    let surveyData = await surveyContract.methods.getSurvey().call()
                    if (surveyData.length > 0) {
                        let required = []
                        let userNfts = {}
                        for (let index = 0; index < surveyData.requiredNft.length; index++) {
                            let requiredNFT = new web3.eth.Contract(IERC721Metadata, surveyData.requiredNft[index])
                            let name = await requiredNFT.methods.name().call()
                            required.push({ name: name, address: surveyData.requiredNft[index] })
                            let balance = await requiredNFT.methods.balanceOf(wallet.account).call()

                            if (balance > 0) {
                                userNfts[`${surveyData.requiredNft[index]}`] = true

                                setHasRequired(true)
                            }
                            setUserNfts(userNfts)
                        }

                        setLoadedSurvey(surveyData)
                        setRequiredNfts(required)
                    }

                    setIsLoading(false)
                } catch (err) {
                    setIsLoading(false)
                    console.log(err)
                }
            }
            setIsLoading(false)
        })()
    }, [wallet, survey])

    const setMessage = async (type, message) => {
        switch (type) {
            case "success":
                toast.addSuccess(message)
                break
            case "error":
                toast.addError(message)
                break
            case "info":
                toast.addInfo(message)
                break
            default:
                break
        }
    }

    const updateConnection = () => {
        const x = wallet.status === "connected" && wallet.chainId === NETWORKS[survey?.network]?.chainId
        setIsConnectedToWallet(x)
        setHasRequired(false)
        return x
    }

    const checkAnswered = async (nft) => {
        web3.setProvider(wallet.ethereum.provider)

        let surveyContract = new web3.eth.Contract(SimpleNFTSurvey, survey.contractAddress)

        return await surveyContract.methods.answered(nft, wallet.account).call()
    }

    const handleRequiredNft = async (nft) => {
        if (userNfts[nft]) {
            if (!(await checkAnswered(nft))) {
                setSelectedNft(nft)
            } else {
                setMessage("info", "You have already answered this survey. Thank you for participating!")
                setSelectedNft(null)
            }
        } else {
            setSelectedNft(null)
        }
    }

    const handlePrevQuestion = () => {
        let prevQuestion = currentQuestion - 1
        if (prevQuestion >= 0) {
            setCurrentQuestion(prevQuestion)
        }
    }

    const handleNextQuestion = () => {
        let nextQuestion = currentQuestion + 1
        if (nextQuestion < loadedSurvey.questions.length) {
            setCurrentQuestion(nextQuestion)
        } else {
            setDetailView(true)
        }
    }

    const handleAnswer = (questionId, option) => {
        setAnswers({
            ...answers,
            [questionId]: {
                answer: option
            }
        })
    }

    const onClose = () => {
        setDetailView(false)
    }

    const onSubmit = async () => {
        let ansArray = await getAnswers()
        await answerSurvey(survey, selectedNft, ansArray)
    }

    const getAnswers = async () => {
        let ans = []
        for (const a in answers) {
            ans.push(answers[a].answer.id)
        }

        return ans
    }

    const answerSurvey = async (survey, selectedNft, optionIds) => {
        web3.setProvider(wallet.ethereum.provider)

        let surveyContract = new web3.eth.Contract(SimpleNFTSurvey, survey.contractAddress)

        let surveyData = await surveyContract.methods.getSurvey().call()

        if (surveyData.isOpen) {
            if (!(await checkAnswered(selectedNft))) {
                setProcessing(true)
                await surveyContract.methods
                    .answerSurvey(selectedNft, optionIds)
                    .send({ from: wallet.account })
                    .on("receipt", function (receipt) {
                        if (receipt.status === true) {
                            setAnswers({})
                            setCurrentQuestion(0)
                            setDetailView(false)
                            setMessage("success", "Successfully answered")
                            setProcessing(false)
                            return true
                        } else {
                            setMessage("error", "Fail on answer the survey")
                            setProcessing(false)
                            return false
                        }
                    })
                    .on("error", function (error) {
                        setMessage("error", error.message)
                        setProcessing(false)
                        return false
                    })
            } else {
                setMessage("info", "You have already answered this survey. Thank you for participating!")
                return false
            }
        } else {
            setMessage("info", "This survey is closed to replies.")
        }
    }

    const Answers = () => {
        return (
            <>
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle className="h3">Answers</CardTitle>

                                {loadedSurvey.questions.map((question) => {
                                    return (
                                        <>
                                            <CardText className="h2">{question.questionTitle}</CardText>
                                            <Col>
                                                {question.options.map((option) => {
                                                    return <div>{`${option.name} - ${option.answers}`}</div>
                                                })}
                                            </Col>
                                        </>
                                    )
                                })}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </>
        )
    }

    return (
        <React.Fragment>
            <div className="content survey-page">
                <BreadCrumb current="Idexo Surveys" />
                {!isConnectedToWallet ? (
                    <ConnectWallet wallet={wallet} chainId={NETWORKS[survey?.network]?.chainId} onChange={updateConnection} />
                ) : isLoading ? (
                    <Modal isOpen={isLoading} centered={true}>
                        <ModalBody className="text-center h3">Loading...</ModalBody>

                        <ModalBody className="text-center">
                            <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="dark" />
                        </ModalBody>
                    </Modal>
                ) : (
                    <div className="survey-body">
                        <div>
                            <Row className="mb-3">
                                <Col className="col-auto">
                                    <a href={"/surveys"}>
                                        <Button>Go to Dashboard</Button>
                                    </a>
                                </Col>
                                <Col className="col-auto">
                                    <Button onClick={() => setOpenAnswers(!openAnswers)}>{openAnswers ? "Hide Answers" : "Show Answers"}</Button>
                                </Col>
                            </Row>
                        </div>

                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <CardTitle className="h3">Survey Details</CardTitle>
                                        <Row>
                                            <Col lg={6}>
                                                <CardText className="card-text-label text-uppercase mb-1">Title </CardText>
                                                <div className="card-text-value mb-1">
                                                    {loadedSurvey.length > 0 ? loadedSurvey.surveyTitle : "loading"}
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={6}>
                                                <CardText className="card-text-label text-uppercase mb-1">Description </CardText>
                                                <div className="card-text-value mb-1">
                                                    {loadedSurvey.length > 0 ? loadedSurvey.surveyDescription : "loading"}
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={6}>
                                                <CardText className="card-text-label text-uppercase mb-1">Required NFTs </CardText>

                                                {requiredNfts.length > 0
                                                    ? requiredNfts.map((nft) => {
                                                          return (
                                                              <div key={nft.address} className="card-text-value mb-1">
                                                                  <a
                                                                      href={`${NETWORKS[survey.network].explorer}/address/${nft.address}`}
                                                                      target="_blank"
                                                                      rel="noopener noreferrer"
                                                                  >
                                                                      {nft.name}
                                                                  </a>
                                                              </div>
                                                          )
                                                      })
                                                    : null}
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                {openAnswers ? (
                                    <Answers />
                                ) : hasRequired ? (
                                    <div className="align-items-center">
                                        <div className="d-flex flex-wrap align-items-center justify-content-center">
                                            <Card>
                                                <CardText className="card-text-label text-uppercase mb-3">
                                                    <CardBody>
                                                        <CardTitle className="h3">
                                                            Question {currentQuestion + 1}/{loadedSurvey?.questions?.length}
                                                        </CardTitle>
                                                        <CardTitle>{loadedSurvey.questions[currentQuestion].questionTitle}</CardTitle>
                                                        {loadedSurvey.questions[currentQuestion].options.map((option) => {
                                                            return (
                                                                <Button
                                                                    key={option.id}
                                                                    className={`btn submit-btn w-100 ${
                                                                        answers[currentQuestion]?.answer.id == option.id ? "orange-btn" : "blue-btn"
                                                                    } text-uppercase`}
                                                                    onClick={() => {
                                                                        handleAnswer(currentQuestion, option)
                                                                        handleNextQuestion()
                                                                    }}
                                                                    style={{ width: "100%" }}
                                                                    disabled={false}
                                                                >
                                                                    {option.name}
                                                                </Button>
                                                            )
                                                        })}
                                                    </CardBody>
                                                </CardText>
                                                <CardFooter>
                                                    <Row className="m-2">
                                                        <Button
                                                            className="btn submit-btn w-50 blue-btn
                                                                                     text-uppercase"
                                                            onClick={() => {
                                                                handlePrevQuestion()
                                                            }}
                                                            style={{ width: "50%" }}
                                                            disabled={false}
                                                        >
                                                            {"<<"}
                                                        </Button>
                                                        <Button
                                                            className="btn submit-btn w-50 blue-btn
                                                                                     text-uppercase"
                                                            onClick={() => {
                                                                handleNextQuestion()
                                                            }}
                                                            style={{ width: "50%" }}
                                                            disabled={answers[currentQuestion]?.answer == null}
                                                        >
                                                            {currentQuestion + 1 > loadedSurvey.questions.length - 1 ? "Submit" : ">>"}
                                                        </Button>
                                                    </Row>
                                                </CardFooter>
                                            </Card>
                                        </div>
                                    </div>
                                ) : (
                                    <CardText className="h2">You do not have NFTs required for this Survey</CardText>
                                )}
                            </Col>
                        </Row>
                    </div>
                )}
            </div>

            <Modal className="task-detail-info-modal" isOpen={!!detailView} onClose={onClose} fade={true} centered={true}>
                {processing ? (
                    <>
                        <ModalBody className="text-center h3">Submitting answer...</ModalBody>

                        <ModalBody className="text-center">
                            <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="dark" />
                        </ModalBody>
                    </>
                ) : (
                    <>
                        <ModalHeader toggle={onClose} tag={"div"}>
                            <div className="d-flex justify-content-between align-items-center">
                                <h5>Submit Info</h5>
                            </div>
                        </ModalHeader>
                        <ModalBody>
                            <Input
                                disabled={false}
                                type="select"
                                value={selectedNft}
                                onChange={(e) => {
                                    handleRequiredNft(e.target.value)
                                }}
                                className="form-control w-100 reward-token-id"
                                placeholder="Select the NFT to Answer"
                            >
                                <option value={null}>Select the NFT to Answer</option>
                                {requiredNfts.map((nft) =>
                                    userNfts[nft.address] ? (
                                        <option key={nft.address} value={nft.address}>
                                            {nft.name}
                                        </option>
                                    ) : null
                                )}
                            </Input>
                            <ModalBody>
                                {loadedSurvey?.questions?.map((question) => {
                                    return (
                                        <div key={question.questionId}>
                                            <p>
                                                <strong>{question.questionTitle}</strong>
                                            </p>

                                            <div>
                                                <p>{answers[question.id - 1]?.answer?.name}</p>
                                            </div>
                                        </div>
                                    )
                                })}
                            </ModalBody>
                            <div className="d-flex justify-content-between">
                                <Button
                                    color="primary"
                                    type="submit"
                                    disabled={processing || selectedNft == null || selectedNft == "Select the NFT to Answer"}
                                    className="waves-effect"
                                    onClick={onSubmit}
                                >
                                    Submit
                                </Button>
                                <Button disabled={processing} color="secondary" type="submit" className="waves-effect" onClick={onClose}>
                                    Return
                                </Button>
                            </div>
                        </ModalBody>
                    </>
                )}
            </Modal>
        </React.Fragment>
    )
}

export default Survey
